import instanceAxios from '../config/api'
import {
  ErreurResponse,
  Pipeline,
  PipelineResponse,
} from '../types/pipelineTypes'
const API_URL = '/pipelines'

export const getAllPipelines = async ({
  search,
  page,
  pageSize,
}: {
  page?: number
  pageSize?: number
  search?: string
}) => {
  try {
    const response = await instanceAxios.get<PipelineResponse>(`${API_URL}`, {
      params: {
        page,
        pageSize,
        search,
      },
    })
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch Pipeline.')
  }
}
export const deletePipelineApi = async (PipelineId: string) => {
  try {
    const response = await instanceAxios.delete<Pipeline[]>(
      `${API_URL}/` + PipelineId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch pipelines.')
  }
}

export const addPipelineApi = async (
  newPipeline: Pipeline
): Promise<Pipeline> => {
  try {
    const response = await instanceAxios.post<Pipeline>(
      `${API_URL}`,
      newPipeline
    )
    return response.data
  } catch (error: any) {
    const erreurResponse: ErreurResponse = {
      statusCode: error.response?.status,
      erreur: true,
      message: error.response?.data?.message || 'Failed to add Pipeline.',
    }
    throw erreurResponse
  }
}

export const getPipelinebyIdApi = async (PipelineId: string) => {
  try {
    const response = await instanceAxios.get<Pipeline>(
      `${API_URL}/` + PipelineId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetchPipeline.')
  }
}

export const updatePipelineApi = async (
  updatePipeline: Pipeline,
  _id: string
): Promise<Pipeline> => {
  try {
    const response = await instanceAxios.put<Pipeline>(
      `${API_URL}/${_id}`,
      updatePipeline
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to PUTPipeline.')
  }
}

export const getPipelinebyMissionApi = async (
  MissionId: string,
  page?: number,
  pageSize?: number
) => {
  try {
    const response = await instanceAxios.get<PipelineResponse>(
      `missions/getPipelines/${MissionId}`,
      {
        params: {
          ...(page !== undefined && { page }),
          ...(pageSize !== undefined && { pageSize }),
        },
      }
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch Pipelines.')
  }
}
